import * as React from 'react'
import { Image, ImageSourcePropType, Platform, Text, TextStyle, TouchableOpacity, View, ViewStyle } from 'react-native'

import apple from '../../../assets/icons/apple-mac.png'
import ShareIcon from '../../../assets/icons/Create-Table.png'
import gmail from '../../../assets/icons/gmail.png'
import phone from '../../../assets/icons/phone.png'
import { fontFamily } from '../../theme/fontFamily'
import { LinearText } from '../linearText/linearText'
import { styles } from './styles'
import { DS } from '../../design-system'

interface ButtonProps {
  testID?: string
  name: string
  type: string
  icon: ImageSourcePropType | string
  onPress: () => void
  textStyle: TextStyle
  btnStyle: ViewStyle | ViewStyle[]
  colorCode: string
  disabled: boolean
}

/**
 *
 * This component is a HOC over the built-in React Native one.
 */
export function Button(props: ButtonProps) {
  const { name, testID, type, icon, onPress, textStyle, btnStyle, colorCode = '#FFF', disabled } = props

  return (
    <TouchableOpacity
      testID={testID}
      onPress={onPress}
      disabled={disabled}
      style={[
        type === 'primary' ? styles.buttonDark : styles.buttonWhite,
        { ...btnStyle },
        {
          backgroundColor:
            icon === 'google' || icon === 'apple' || icon === 'email' || icon === 'phone' ? '#F6F2E9' : colorCode
        }
      ]}
    >
      {icon === 'google' ? (
        <View style={{ flexDirection: 'row', flex: 1 }}>
          <View style={styles.leftView}>
            <Image source={gmail} style={styles.icon} resizeMode={'contain'} />
          </View>
          <View style={Platform.OS === 'web' ? styles.rightViewWeb : styles.rightView}>
            <Text
              allowFontScaling={false}
              textBreakStrategy={'simple'}
              style={[
                type === 'primary' ? styles.buttonDarkText : styles.buttonWhiteText,
                { fontFamily: fontFamily.GTAmericaStandardMedium }
              ]}
            >
              {name}
            </Text>
          </View>
        </View>
      ) : null}
      {icon === 'apple' ? (
        <View style={{ flexDirection: 'row', flex: 1 }}>
          <View style={styles.leftView}>
            <Image source={apple} style={styles.icon} resizeMode={'contain'} />
          </View>
          <View style={styles.rightView}>
            <Text
              allowFontScaling={false}
              style={[
                type === 'primary' ? styles.buttonDarkText : styles.buttonWhiteText,
                { fontFamily: fontFamily.GTAmericaStandardMedium }
              ]}
            >
              {name}
            </Text>
          </View>
        </View>
      ) : null}
      {icon === '' ? (
        <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
          <View style={styles.rightView}>
            <DS.Text variant="Body Medium/Medium" style={[textStyle]}>
              {name}
            </DS.Text>
          </View>
        </View>
      ) : null}
      {icon === 'phone' ? (
        <View style={{ flexDirection: 'row', flex: 1 }}>
          <View style={styles.leftView}>
            <Image source={phone} style={styles.icon} resizeMode={'contain'} />
          </View>
          <View style={styles.rightView}>
            <Text
              allowFontScaling={false}
              style={[
                type === 'primary' ? styles.buttonDarkText : styles.buttonWhiteText,
                { fontFamily: fontFamily.GTAmericaStandardMedium }
              ]}
            >
              {name}
            </Text>
          </View>
        </View>
      ) : null}
      {type === 'primary' ? (
        <View>
          <Image style={styles.shareImageIcon} source={ShareIcon} />
        </View>
      ) : null}
      {type === 'primary' ? (
        <View style={{ flex: 2 }}>
          <LinearText txt="" />
          <Text allowFontScaling={false} style={styles.buttonTitleText}>
            Create a table, Invite your friends {'\n'}and play face-to-face
          </Text>
        </View>
      ) : null}
      {type === 'join' ? (
        <View style={styles.containerRow}>
          <Text allowFontScaling={false} style={[textStyle]}>
            {name}
          </Text>
        </View>
      ) : null}
      {['bet', 'call', 'check', 'raise', 'fold', 'allin', 'leave', 'imBack'].includes(type) ? (
        <View style={styles.containerRow}>
          <Text allowFontScaling={false} style={[textStyle, { color: '#232335' }]}>
            {name}
          </Text>
        </View>
      ) : null}
    </TouchableOpacity>
  )
}
